import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import NavBar from '../Navbar/NavBar';
import useNewsItem from '../../hooks/useNewsItem';
import RenderContent from './RenderContent';
import ShareOption from './ShareOption';
import CommentSection from './CommentSection';
import NewsletterSubscription from './NewsletterSubscription';
import { formatDateSimple } from '../../utils/dateUtils';

const NewsDetail = () => {
    const navigate = useNavigate();
    const newsItem = useNewsItem();

    if (!newsItem) {
        return (
            <Box sx={{ mt: 10, maxWidth: '800px', mx: 'auto', p: { xs: 2, md: 4 } }}>
                <NavBar />
                <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: 'black', mt: 4 }}>News item not found!!!</Typography>
                <Button variant="contained" color="primary" sx={{ mt: 10, borderRadius: 10, ':hover': { backgroundColor: '#f39c12', color: 'white' } }} onClick={() => navigate(-1)}>Back</Button>
            </Box>
        );
    }

    // Safely access newsItem.content with an empty array as a fallback
    const content = newsItem.content || [];

    return (
        <Box>
            <NavBar />
            <Box
                sx={{
                    borderRadius: '1.5rem',
                    mt: 5,
                    maxWidth: '800px',
                    mx: { xs: '1rem', sm: '4rem', md: '6rem', lg: '7rem' },
                    p: { xs: 2, md: 2 }
                }}
            >
                <Typography variant="h4" component="h1"
                    sx={{ display: 'flex', justifyContent: 'center', fontWeight: 'bold', color: 'black', mt: 5 }}
                >
                    {newsItem.title}
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 2, fontSize: '0.875rem' }}>
                    <Typography component="span">Published by: {newsItem.author}</Typography>
                    <Typography component="span">{formatDateSimple(newsItem.date)}</Typography>
                </Box>

                {content.map((contentItem, index) => (
                    <RenderContent key={index} content={contentItem} />
                ))}

                <ShareOption />
            </Box>
            <CommentSection />
            <NewsletterSubscription />
            {/* <FooterOne /> */}
        </Box>
    );
};

export default NewsDetail;
